/**
 * RoleSwitcher — demo-only role picker (auth off, CONTRACT §11.1). Hidden unless the principal
 * came from the demo identity. Role ids and their labels arrive as props.
 */

import './AgentLayout.css';

export default function RoleSwitcher({ principal = null, roles = [], roleLabel = (r) => r, onChange }) {
  if (!principal || principal.source !== 'demo') return null;
  const current = principal.roles?.[0] ?? '';
  const options = roles.includes(current) || !current ? roles : [current, ...roles];
  return (
    <label className="agent-role" title="Demo role (switches what you may approve)">
      <span className="agent-sr">Signed in as</span>
      <select
        className="agent-role__select"
        value={current}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={options.length < 2}
      >
        {options.map((r) => <option key={r} value={r}>{roleLabel(r)}</option>)}
      </select>
    </label>
  );
}
